'use strict';

import '../../../../../shared/data';

import 'bootstrap/js/tooltip';
import {
    copyToClipboard,
    scrollToElement,
    addCommasToNumber,
    doEmailPatternTest,
    doContactInfoTest
} from "../../../../../shared/utils";
import {Listings} from "../../../../../shared/js/Listings";
import {TradesCountBox_v2} from "../../../../../shared/js/TradesCountBox_v2";
import {HtmlSanitizer} from '../../../../../vendor/HtmlSanitizer';
import '../../../../../vendor/jquery.jScale.js';

const PROFILE_TYPE = {
    company: 'company',
    user: 'user'
};

var _profiles = (function () {

    var exports = {};
    exports.pageId = $('.body-profile').attr('id');
    exports.companyid = $('.body-profile').data('companyid');
    exports.userid = $('.body-profile').data('userid');
    exports.tabPrefix = 'tab_';
    exports.urlString = document.location.toString();
    exports.profileType = '';
    exports.debugMode = false;

    exports.init = function () {
        this.tabPaths = this.initTabGetPaths();
        this.ajxDataLoad = this.initAjaxDataLoad();
        this.inPage = this.initGlobalVars();

        if (this.debugMode) {
            console.debug(this.inPage);
        }

        // find page to load
        switch (this.pageId) {
            case 'company_profile':
                this.initCompanyProfile();
                break;
            case 'user_profile':
                this.initUserProfile();
                break;
        }

        // phone number modal - either user or company
        $('#btn_phone_modal').click(function (e) {
            _profiles.doProfileModalOpen($(this), function () {
                $('#phoneCopyButton').tooltip();

                $('#phoneCopyButton').click(function () {
                    var phoneInput = document.querySelector('input[name=phone]');
                    copyToClipboard(phoneInput, function () {
                        $('#phoneCopySuccess').slideDown('fast');
                    });
                });
            });
        });

        // do a simple modal open - either user or company
        $('#btn_address_modal, #btn_report_modal, #btn_website_modal, #btn_user_image').click(function (e) {
            _profiles.doProfileModalOpen($(this), null);
        });

        // do back to listings click
        $('#back_to_listings').click(function (e) {
            var fallBackUrl = $(this).data('history-fallback');
            var historyBack = $(this).data('history-cnt');
            tradeloop.historyBackWFallbackUrl(fallBackUrl, historyBack);
            return false;
        });

    };

    // USER PROFILE
    exports.initUserProfile = function () {
        _profiles.profileType = PROFILE_TYPE.user;
        var uProfile = {
            loadTab: function (tab) {
                _profiles.initLoadUserTabData(tab);
                return this;
            },
            initTabLoad: function () {
                _profiles.loadedTabs = _profiles.initLoadedUserTabs();
                return this;
            },
            initTabFromUrl: function () {
                // find tab we need to load on page hit - people may bookmark a tab
                var url = _profiles.urlString;
                if (url.match('#')) {
                    var hash = url.split('#')[1].replace(_profiles.tabPrefix, "");
                    var $element = $('.nav-tabs a[href="#' + hash + '"]');
                    if ($element) {
                        $element.tab('show');
                        this.loadTab(hash);
                    }
                }
                return this;
            },
            loadTabsInBackground: function () {
                //load tabs in background
                if (typeof _profiles.loadedTabs == 'undefined') {
                    this.initTabLoad();
                }

                var tabs = _profiles.loadedTabs;
                const tabKeys = Object.keys(tabs);
                tabKeys.forEach((key, index) => {
                    if (!tabs[key]) {
                        this.loadTab(key);
                    }
                });

                return this;
            },
        }
        uProfile.initTabLoad().initTabFromUrl().loadTabsInBackground();

        // Change hash when tab is switched
        $('.nav-tabs a').on('shown.bs.tab', function (e) {
            var new_hash = e.target.hash.replace("#", "#" + _profiles.tabPrefix);

            if (history.pushState) {
                history.pushState(null, null, new_hash);   // does not affect popstate
            } else {
                window.location.hash = new_hash; // does affect popstate
            }

            //update back count for link
            tradeloop.incrementHistoryOnElm('#back_to_listings', 'history-cnt');
        });

        // messaging modal - need to really send message
        $('#btn_message_modal').click(function (e) {
            _profiles.doProfileModalOpen($(this), function () {
                $('#send-message-btn').click(function () {
                    var isInError = 0;
                    var postTo = '/modal/users/full_profile/send_message/' + _profiles.userid;
                    var postData = _profiles.initAjaxDataLoad();
                    var subject = HtmlSanitizer.SanitizeHtml($('#subject-box').val());
                    var message = HtmlSanitizer.SanitizeHtml($('#message-box').val());

                    if (isInError == 0) {
                        isInError = _profiles.doMessageChecks(subject, 'subject');
                    }

                    if (isInError == 0) {
                        isInError = _profiles.doMessageChecks(message, 'message');
                    }

                    if (isInError == 0) {
                        $.extend(postData, {
                            ui: $('input#ui').val(),
                            en: $('input#en').val(),
                            subject: subject,
                            message: message,
                        });

                        if (_profiles.debugMode) {
                            console.log('SENDING MESSAGE:');
                            console.log('postTo: ' + postTo);
                            console.log('subject: ' + subject);
                            console.log('message: ' + message);
                            console.debug(postData);
                        } else {

                            tradeloop.toggleMeEdits('hide_full_modal');

                            framework.post(postTo, postData, function (r) {
                                tradeloop.show_message('Your message has been sent!');
                                $('.modal .close').click();
                            }, function (e, data) {
                                tradeloop.toggleMeEdits('show_full_modal');
                                tradeloop.show_modal_error(data.error);

                                console.log('data: ' + data);

                            });
                        }
                    }

                });
            });
        });
        // END SEND USER MESSAGE
    };

    // COMPANY PROFILE
    exports.initCompanyProfile = function () {
        _profiles.profileType = PROFILE_TYPE.company;
        var cProfile = {
            loadTab: function (tab) {
                _profiles.initLoadCompanyTabData(tab);
                return this;
            },
            initTabLoad: function () {
                _profiles.loadedTabs = _profiles.initLoadedCompanyTabs();
                return this;
            },
            initTabFromUrl: function () {
                // find tab we need to load on page hit - people may bookmark a tab
                var url = _profiles.urlString;
                if (url.match('#')) {
                    var hash = url.split('#')[1].replace(_profiles.tabPrefix, "");
                    var $element = $('.nav-tabs a[href="#' + hash + '"]');
                    if ($element) {
                        $element.tab('show');
                        this.loadTab(hash);
                    }
                }
                return this;
            },
            loadTabsInBackground: function () {
                //load tabs in background
                if (typeof _profiles.loadedTabs == 'undefined') {
                    this.initTabLoad();
                }

                var tabs = _profiles.loadedTabs;
                const tabKeys = Object.keys(tabs);
                tabKeys.forEach((key, index) => {
                    if (!tabs[key]) {
                        this.loadTab(key);
                    }
                });

                return this;
            },
        }
        cProfile.initTabLoad().initTabFromUrl().loadTabsInBackground();


        // Change hash when tab is switched
        $('.nav-tabs a').on('shown.bs.tab', function (e) {
            var new_hash = e.target.hash.replace("#", "#" + _profiles.tabPrefix);

            if (history.pushState) {
                history.pushState(null, null, new_hash);   // does not affect popstate
            } else {
                window.location.hash = new_hash; // does affect popstate
            }

            //update back count for link
            tradeloop.incrementHistoryOnElm('#back_to_listings', 'history-cnt');
        });


        // show message 
        $('#btn_message_modal').click(function (e) {
            _profiles.doProfileModalOpen($(this), null);
        });

    };


    exports.initLoadCompanyTabData = function (tab) {
        var tab_to_show = this.clearHashFromString(tab);
        var alreadyLoaded = this.isTabLoaded(tab_to_show);

        if (this.debugMode) {
            console.debug('TAB: ' + tab_to_show + ' LOADED: ' + alreadyLoaded);
        }

        // don't reload the tab over and over - just on the first hit
        if (!alreadyLoaded) {
            // get data for the tab
            switch (tab_to_show) {
                case 'storefront':
                    TradesCountBox_v2.populate({
                        mode: 'profile',
                        allowHiding: false,
                        allowRemove: true,
                        removeTemplateMargin: true,
                        showManuBoxes: true,
                        showBackToManusLink: true,
                        tableTitle: 'Current Inventory',
                        filters: window.init_filters,
                        container: $('#trades_box_container')
                    });

                    _data.refresh(function() {
                        Listings.init();
                        Listings.getListings(function() {
                            if (_data.filters.hasOwnProperty('user_id')) {
                                scrollToElement($('#tabs'), 500);
                            }
                        });
                    }, false);
                    break;

                case 'employees':
                case 'stats':
                case 'diligence':
                    this.doGetLoadHtmlData(tab_to_show);
                    break;

                case 'about':
                    $('img.scale-img-100').jScale({ls:'100px'});
                    this.doGetLoadHtmlData(tab_to_show);
                    break;
            }

            // set to loaded already, so we don't show it over and over
            switch (tab_to_show) {
                case 'storefront':
                case 'employees':
                case 'stats':
                case 'about':
                case 'diligence':
                    this.setTabLoaded(tab_to_show);
                    break;
            }
        }

        if (this.debugMode) {
            console.debug(this.loadedTabs);
        }

    };


    exports.initLoadUserTabData = function (tab) {
        var tab_to_show = this.clearHashFromString(tab);
        var alreadyLoaded = this.isTabLoaded(tab_to_show);

        if (this.debugMode) {
            console.debug('TAB: ' + tab_to_show + ' LOADED: ' + alreadyLoaded);
        }

        // don't reload the tab over and over - just on the first hit
        if (!alreadyLoaded) {
            // get data for the tab
            switch (tab_to_show) {
                case 'storefront':
                    TradesCountBox_v2.populate({
                        mode: 'profile',
                        allowHiding: false,
                        allowRemove: true,
                        removeTemplateMargin: true,
                        showManuBoxes: true,
                        showBackToManusLink: true,
                        tableTitle: 'Current Inventory',
                        filters: window.init_filters,
                        container: $('#trades_box_container')
                    });

                    _data.refresh(function() {
                        Listings.init();
                        Listings.getListings(function() {}, false);
                    });

                    break;

                case 'about':
                    // show or hide subcategories
                    $('#show_subcategories, #hide_subcategories').click(function() {
                        $('#short_categories').toggle($('#detailed_categories').css('display') !== 'none');
                        $('#detailed_categories').toggle($('#detailed_categories').css('display') === 'none');
                    });
                    _profiles.doGetUserAjaxData('inventory');
                    _profiles.doGetUserAjaxData('listings');
                    break;

                case 'network':
                    _profiles.doGetLoadHtmlData('connections');

                    // show more or less connections
                    $(document).on("click", '.more-connections, .less-connections', function (e) {
                        var $elm = $(this);
                        var hideId = '#' + $elm.data('wrapperid');
                        var showId = '#' + $elm.data('showid');

                        $(hideId).fadeOut(300, 'linear', function () {
                            $(showId).fadeIn(300, 'linear');
                        });

                    });
                    break;
            }

            // set to loaded already so we don't show it over and over
            switch (tab_to_show) {
                case 'storefront':
                case 'about':
                case 'network':
                    this.setTabLoaded(tab_to_show);
                    break;
            }
        }

        if (this.debugMode) {
            console.debug(this.loadedTabs);
        }

    };

    exports.initAjaxDataLoad = function () {
        var data = {
            "_token": $('input[name="_token"]:first').val(),
            "x-sender": "js",
        };

        if (typeof tlpxtoken != 'undefined') {
            data.tlpxtoken = tlpxtoken;
        }

        return data;
    };

    exports.initTabGetPaths = function () {
        var cBsPath = '/companies/profiles/' + this.companyid;
        var uBsPath = '/users/profiles/' + this.userid;
        var tabsPaths = {};

        tabsPaths[PROFILE_TYPE.company] = {
            about: cBsPath + '/about',
            employees: cBsPath + '/employees',
            stats: cBsPath + '/stats',
            diligence: cBsPath + '/diligence',
        };

        tabsPaths[PROFILE_TYPE.user] = {
            connections: uBsPath + '/connections',
        };

        if (this.debugMode) {
            console.debug(tabsPaths);
        }

        return tabsPaths;
    };

    exports.initLoadedUserTabs = function () {
        var tabsLoaded = {
            storefront: false,
            about: false,
        };

        if (this.debugMode) {
            console.debug(tabsLoaded);
        }

        return tabsLoaded;
    };

    exports.initLoadedCompanyTabs = function () {
        var tabsLoaded = {
            storefront: false,
            employees: false,
            diligence: false,
            about: false,
            stats: false,
        };

        if (this.debugMode) {
            console.debug(tabsLoaded);
        }

        return tabsLoaded;
    };

    exports.initLoadedUserTabs = function () {
        var tabsLoaded = {
            storefront: false,
            about: false,
            network: false,
        };

        if (this.debugMode) {
            console.debug(tabsLoaded);
        }

        return tabsLoaded;
    };

    exports.isTabLoaded = function (tab) {
        return this.loadedTabs[tab];
    };

    exports.setTabLoaded = function (tab) {
        this.loadedTabs[tab] = true;
    };

    exports.clearHashFromString = function (str) {
        if (str.match('#')) {
            return str.split('#')[1].replace(this.tabPrefix, "");
        } else {
            return str;
        }
    };

    exports.doGetLoadHtmlData = function (tab, callback) {
        var getPath = this.tabPaths[_profiles.profileType][tab];

        if (this.debugMode) {
            console.debug('LOAD: ' + tab + ' PATH: ' + getPath);
        }

        framework.get(getPath, this.ajxDataLoad, function (r) {
            $('div#' + tab).html(r.html);
            if (callback && typeof callback === "function") {
                callback(r);
            }
        }, function (e, data) {
            //alert(data.error);
        });
    };

    exports.doGetUserAjaxData = function (target) {
        var getPath = '/users/profiles/' + this.userid + '/jsons/' + target;

        framework.get(getPath, this.ajxDataLoad, function (r) {
            switch (target) {
                case 'inventory':
                    $('div#user_inventory_count').html(addCommasToNumber(r.data.trades_count));
                    break;

                case 'listings':
                    $('div#user_listings_count').html(addCommasToNumber(r.data.total));
                    break;
            }
        }, function (e, data) {
            //alert(data.error);
        });
    };

    exports.initGlobalVars = function () {
        var inPage = {
            contactInfo:        typeof has_Contact_Information !== 'undefined' ? has_Contact_Information : false,
            overLimit:          typeof oUlimit !== 'undefined' ? oUlimit : false,
            displayName:        typeof has_display_name !== 'undefined' ? has_display_name : false,
            cp_displayName:     typeof has_cp_display_name !== 'undefined' ? has_cp_display_name : false,
            levelTwoVerified:   typeof has_uphvd !== 'undefined' ? has_uphvd : false,
            memView:            typeof uMemV !== 'undefined' ? uMemV : false,
            myProfie:           typeof myPf !== 'undefined' ? myPf : false,
            isEntMem:           typeof cEntp !== 'undefined' ? cEntp : false,
        };

        return inPage;
    };

    exports.checkPageHasUserActions = function (elm) {
        var elmId = this.getIdFromElm(elm);

        if (this.debugMode) {
            console.debug('check requirements: ' + elmId);
        }

        switch (elmId) {
            case 'btn_website_modal':
                if (this.inPage.isEntMem) {
                    return false;
                }
                break;
        }

        if (!is_logged_in) {
            switch (elmId) {
                case 'btn_report_modal':
                    return 'register';
                default:
                    return 'gates/bifurcating';
            }
        }

        if (!this.inPage.contactInfo) {
            return 'gates-usage/public_usage_gate_contact_info';
        }

        if (!this.inPage.displayName) {
            return 'display_name/user';
        }

        if (!this.inPage.cp_displayName) {
            return 'display_name/company';
        }

        if (!this.inPage.memView) {
            switch (elmId) {
                case 'btn_report_modal':
                    return false;
                default:
                    return 'gates/bifurcating';
            }
        }

        if (this.inPage.overLimit) {
            if (this.inPage.memView) {
                return 'member_over_usage_limit';
            } else {
                return 'gates/public_usage_gate_over_limit';
            }
        }

        if (!this.inPage.levelTwoVerified) {
            if (!this.inPage.memView) {
                return 'gates-usage/public_usage_gate_verify_level_two';
            } 
        }
        
        return false;
    };

    exports.doProfileModalOpen = function (elm, onLoad) {
        var checkRequirements = this.checkPageHasUserActions(elm);
        var data = this.ajxDataLoad;
        data.cta = this.getDataCtaFromElm(elm);

        if (this.debugMode) {
            console.debug('checkRequirements: ' + checkRequirements);
        }

        if (checkRequirements) {
            tradeloop.modal(checkRequirements, null, data, data.cta, 'cta');
            return;
        }

        tradeloop.modal(this.getCleanDataModalPath(elm), onLoad, data, data.cta, 'cta');
    };

    exports.getCleanDataModalPath = function (elm) {
        return $(elm).data('modal-path').replace('/modal/', '');
    };

    exports.getDataCtaFromElm = function (elm) {
        return $(elm).data('cta');
    };

    exports.getIdFromElm = function (elm) {
        return $(elm).attr('id');
    };

    exports.doMessageChecks = function (message, label) {
        var isInError = 0;

        if (message.length == 0) {
            alert('Please add a ' + label + '.');
            isInError = 1;
        } else {
            if (doEmailPatternTest(message)) {
                alert('Do not include email in your ' + label + '.');
                isInError = 1;
            } else {

                if (doContactInfoTest(message)) {
                    alert('Do not include contact info in your ' + label + '.');
                    isInError = 1;
                }
            }
        }

        return isInError;
    };

    return exports;

})();

$(document).ready(function () {
    _profiles.init();
});